import React from "react";

export const ErrorWrapper = ({ children }: { children: React.ReactNode }) => {
  return (
    <div className="cw-h-full cw-w-full cw-flex cw-flex-col cw-items-center cw-bg-default ">
      <div className="md:cw-w-[600px] cw-w-full cw-py-16 cw-px-4">{children}</div>
    </div>
  );
};
